module.exports = __webpack_public_path__ + "img/ic_03.d77c5710.png";